var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarFleetOverview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.5,
    height: 32.782,
    viewBox: "0 0 35.5 32.782",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-analytics-1313241",
    transform: "translate(-45.9 -88.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M77.151,116.4h-27a4,4,0,0,1-4-4V93.218a4,4,0,0,1,4-4h27a4,4,0,0,1,4,4V112.4A4,4,0,0,1,77.151,116.4Zm-27-25.724a2.543,2.543,0,0,0-2.54,2.54V112.4a2.543,2.543,0,0,0,2.54,2.54h27a2.543,2.543,0,0,0,2.54-2.54V93.218a2.543,2.543,0,0,0-2.54-2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M414.614,909.978a.728.728,0,0,1-.7-.514l-1.413-4.58h-6.779l-1.413,4.58a.729.729,0,0,1-1.393-.43l1.572-5.094a.729.729,0,0,1,.7-.514h7.855a.729.729,0,0,1,.7.514l1.572,5.094a.729.729,0,0,1-.481.911.71.71,0,0,1-.215.033Z",
    transform: "translate(-345.466 -788.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M361.464,1066.1H346.881a.729.729,0,0,1,0-1.458h14.583a.729.729,0,0,1,0,1.458Z",
    transform: "translate(-290.523 -944.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M80.491,705.742H46.951a.729.729,0,0,1,0-1.458H80.491a.729.729,0,0,1,0,1.458Z",
    transform: "translate(-0.07 -595.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M977.531,794.5a.725.725,0,0,1-.51-.219.7.7,0,0,1-.219-.511.728.728,0,0,1,.058-.277.61.61,0,0,1,.161-.241.754.754,0,0,1,1.028,0,.694.694,0,0,1,.16.241.73.73,0,0,1,.058.277.7.7,0,0,1-.219.511A.731.731,0,0,1,977.531,794.5Z",
    transform: "translate(-901.247 -681.593)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M172.831,401.259a.729.729,0,0,1-.729-.729v-6.107a.729.729,0,1,1,1.458,0v6.107A.729.729,0,0,1,172.831,401.259Z",
    transform: "translate(-121.972 -294.854)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M288.221,468.3a.729.729,0,0,1-.729-.729v-3.919a.729.729,0,1,1,1.458,0v3.919A.729.729,0,0,1,288.221,468.3Z",
    transform: "translate(-233.716 -361.896)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M403.6,334.216a.729.729,0,0,1-.729-.729v-8.294a.729.729,0,0,1,1.458,0v8.294A.729.729,0,0,1,403.6,334.216Z",
    transform: "translate(-345.451 -227.811)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M518.991,378.908a.729.729,0,0,1-.729-.729v-6.836a.729.729,0,0,1,1.458,0v6.836A.729.729,0,0,1,518.991,378.908Z",
    transform: "translate(-457.195 -272.503)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M686.449,273.109a.727.727,0,0,1-.516-.214l-3.348-3.348a.729.729,0,0,1,0-1.031,5.456,5.456,0,0,1,7.926.217.729.729,0,0,1-.056,1.03l-3.519,3.159a.727.727,0,0,1-.487.187Zm-2.271-4.031,2.3,2.3,2.413-2.166a4.1,4.1,0,0,0-4.711-.132Z",
    transform: "translate(-616.12 -172.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M643.934,320.35a5.464,5.464,0,0,1-3.864-9.328.729.729,0,0,1,1.031,0l2.86,2.86,3.006-2.7a.728.728,0,0,1,1.03.055,5.459,5.459,0,0,1-4.062,9.112Zm-3.3-7.736a4.01,4.01,0,1,0,6.717.185l-2.928,2.628a.729.729,0,0,1-1-.027Z",
    transform: "translate(-573.605 -214.587)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M789.061,422.958a.729.729,0,0,1-.729-.729v-4.736a.729.729,0,0,1,1.458,0v4.736A.729.729,0,0,1,789.061,422.958Z",
    transform: "translate(-718.732 -317.195)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarFleetOverview);
export default __webpack_public_path__ + "static/media/sidebar-fleet-overview.74a06cec7c23290c0bed7e1a4968b0b3.svg";
export { ForwardRef as ReactComponent };